import { html } from "lit-element";
import { DrawSVGBaseModule } from "../../ModuleBase/svg-base-module";

export class DrawOdmModule extends DrawSVGBaseModule {
	constructor(canvas) {
		super(canvas);

		this.name = "odm";
		this.icon = svg_odm;
	}
}

window.customElements.define("inspx-draw-odm-module", DrawOdmModule);

const svg_odm = html`
<svg width="90" height="90" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg">
 <g>
  <title>Layer 1</title>
  <rect id="svg_1" height="90" width="89.6673" fill="#ffffff" stroke="#444444"/>
  <line stroke="#444444" id="svg_2" y2="20.9231" x2="89.53381" y1="20.9231" x1="0.66742" fill="none"/>
  <line id="svg_3" y2="67.74206" x2="89.44483" y1="67.74206" fill="none" x1="0.26697" stroke="#444444"/>
  <text fill="#000000" stroke-width="0" stroke-dasharray="null" stroke-linejoin="null" stroke-linecap="null" x="41.26099" y="64.08508" id="svg_6" font-size="24" font-family="Sans-serif" text-anchor="middle" xml:space="preserve" transform="matrix(1.6464994810832494,0,0,1.2534014873479387,-23.078224723274012,-25.986287052368777) " stroke="#000000">odm</text>
 </g>
</svg>`;
